export default __webpack_public_path__ + "static/media/package_13.d08a85b1.png";